import { useEffect, useState } from 'react'
import { APP_NAME, APP_TAGLINE } from '../../constants'

interface SplashScreenProps {
  onFinished?: () => void
  minimumDisplayMs?: number
}

export function SplashScreen({ onFinished, minimumDisplayMs = 800 }: SplashScreenProps) {
  const [fadeOut, setFadeOut] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true)
      setTimeout(() => onFinished?.(), 300)
    }, minimumDisplayMs)
    return () => clearTimeout(timer)
  }, [minimumDisplayMs, onFinished])

  return (
    <div
      className={`fixed inset-0 z-50 flex flex-col items-center justify-center bg-slate-950 transition-opacity duration-300 ${
        fadeOut ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      {/* Logo */}
      <div className="splash-logo mb-6 flex h-20 w-20 items-center justify-center rounded-2xl bg-indigo-600 text-3xl font-bold text-white shadow-lg">
        S
      </div>

      {/* App Name */}
      <h1 className="mb-2 text-3xl font-bold text-white">{APP_NAME}</h1>
      <p className="mb-8 text-sm font-light text-slate-400">{APP_TAGLINE}</p>

      {/* Loading Indicator */}
      <div className="flex flex-col items-center gap-3">
        <div className="splash-spinner h-8 w-8 rounded-full border-[3px] border-slate-700 border-t-indigo-500" />
        <p className="text-sm font-medium text-indigo-400">Loading your finances…</p>
      </div>
    </div>
  )
}
